<template>
  <v-dialog
    :value="true"
    max-width="800"
    persistent
  >
    <v-card
      style="position: relative"
    >
      <iframe
        :src="`https://survey.zohopublic.com/zs/0gyPpv?e=${user && user.email ? encodeURIComponent(user.email) : ''}`"
        frameborder="0"
        style="height:700px;width:100%;"
        marginwidth="0"
        marginheight="0"
        scrolling="auto"
        @load="loading = false"
      ></iframe>
      <v-progress-circular
        v-if="loading"
        color="primary"
        size="30"
        style="position: absolute; left: 50%; top: 50%; margin-left: -15px; margin-top: -15px;"
        indeterminate
      />
      <v-btn
        icon
        style="position: absolute; top: 10px; right: 10px;z-index: 100"
        @click="$store.commit('setSupportDialog', false)"
      >
        <v-icon>fa fa-times</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters(['user'])
  }
}
</script>
